/**
 * Authentication types and enums
 * These represent internal application state and configuration types
 */

import type { UserSessionDTO, UserDTO } from './dtos';
import type { AuthTenantDTO } from '../manage/dtos';

// Enums
export enum UserRole {
  SYSTEM_ADMIN = 'SYSTEM_ADMIN',
  UNIVERSITY_ADMIN = 'UNIVERSITY_ADMIN',
  FACULTY_ADMIN = 'FACULTY_ADMIN',
  PROFESSOR = 'PROFESSOR',
  COURSE_REPRESENTATIVE = 'COURSE_REPRESENTATIVE',
}

// Auth state interfaces for store management
export interface AuthState {
  user: UserDTO | null;
  accessToken: string | null;
  idToken: string | null;
  refreshToken: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
}

export interface MultiTenantAuthState extends AuthState {
  currentTenant: AuthTenantDTO | null;
  accessibleTenants: AuthTenantDTO[];
  userSession: UserSessionDTO | null;
  isSwitchingTenant: boolean;
  tenantSwitchError: string | null;
  lastTenantRefresh: string | null;
}
